// 노드 root 셸(#480)의 전선 규약 — pve-xtermjs 의 것이다. 로그인 줄은 백엔드가 보내므로 여기엔 없다.
// 입력은 `0:<UTF-8 바이트 수>:<데이터>`, 크기는 `1:<열>:<행>:`, 핑은 `2`. 노드가 처음 보내는 것은 `OK` 이고
// 그 뒤가 셸의 출력이다. 보내는 것은 모두 바이너리 프레임이다(중계가 바이너리만 나른다).

const encoder = new TextEncoder()

/** WebSocket.send 가 받는 모양(ArrayBuffer 위의 바이트)으로. */
const bytes = (s: string): Uint8Array<ArrayBuffer> => new Uint8Array(encoder.encode(s))

export function shellInput(data: string): Uint8Array<ArrayBuffer> {
  return bytes(`0:${encoder.encode(data).length}:${data}`)
}

export function shellResize(cols: number, rows: number): Uint8Array<ArrayBuffer> {
  return bytes(`1:${cols}:${rows}:`)
}

export const SHELL_PING = bytes('2')

/** 노드에서 온 한 덩이를 셸 출력으로. 아직 `OK` 를 받지 못했으면 그것을 떼어 내고 연결됐다고 말한다. */
export function shellOutput(connected: boolean, chunk: Uint8Array): { connected: boolean; data: Uint8Array } {
  if (connected) return { connected, data: chunk }
  if (chunk.length >= 2 && chunk[0] === 0x4f && chunk[1] === 0x4b) return { connected: true, data: chunk.subarray(2) }
  return { connected: false, data: new Uint8Array() }
}
